// reminder views in CC
export const ListAllReminder = "listAllReminder";
export const AddReminder = "addReminder";
export const EditReminder = "editReminder";
export const NO_DATA_AVAILABLE = "No Data Available";
export const NO_DATA_FOUND = "No Data Found";
export const NO_INSTANCE_ADDED = "No instance is added to this program click on '+' icon to add the instance.";
export const NO_INTERVENTIONS_ASSIGNED = "No Interventions are assigned to this Program."
export const NO_PROGRAM_AVAILABLE =  "No Programs are Available."
export const NO_TASK_ASSIGNED = "No Tasks Assigned."
export const NO_UPCOMING_REMINDER = "No Upcoming reminders available"
export const DATA_LOADING = "Data Loading... Please wait for a moment!";
